import * as angular from "angular";
import { HouseOccupant } from "../../models/house-occupant.model";
import { PermissionCheck } from "../../shared/permission";
import { DialogUtils } from "../../helper/dialog.helper";
import { ScreenUtils } from "../../helper/screen.helper";
import { ToastUtils } from "../../helper/toast.helper";
import { DuplicatesDataProvider } from "../../data-provider/duplicates.dp";
import { Utils } from "../../helper/utils.helper";

let DuplicatesComponent = {
    selector: "vcDuplicates",
    templateUrl: "/angular/components/duplicates/duplicates.component.html",
    bindings: {},
    controller: class DuplicatesController {
        private $scope: any;
        private $filter: any;
        public __env: any;

        private dataProvider: DuplicatesDataProvider;
        public permissionProvider: PermissionCheck;

        private dialog: DialogUtils;
        private toast: ToastUtils;
        public screen: ScreenUtils;

        public isLeaderView: boolean;
        public description = "";
        public latest = "";
        public duplicates: Array<any>;
        public count: number | null = null;
        public loading = false;
        public subheading = "";

        constructor(
            $scope: any,
            $filter: any,
            __env: any,
            DuplicatesDataProvider: DuplicatesDataProvider,
            PermissionCheck: PermissionCheck,
            DialogUtils: DialogUtils,
            ToastUtils: ToastUtils,
            ScreenUtils: ScreenUtils,
            Utils: Utils,
            __app_type: string
        ) {
            this.$scope = $scope;
            this.$filter = $filter;
            this.__env = __env;

            this.dataProvider = DuplicatesDataProvider;
            this.permissionProvider = PermissionCheck;

            this.toast = ToastUtils;
            this.dialog = DialogUtils;
            this.screen = ScreenUtils;

            Utils.accessCheck();
            Utils.runWootric();

            this.subheading = `If there are any potential duplicate ${this.__env.strings.voters}, they will show up here.`;
            this.isLeaderView = __app_type == "LEADER";
            this.description = `Clean up potential duplicate ${this.__env.strings.voters} in your database`;
            this.getDuplicates();

            this.dataProvider.latest().then((data: any) => {
                this.latest = data.creationdatetime;
            });
        }

        getDuplicates(): void {
            this.loading = true;
            this.dataProvider.all().then((json: any) => {
                this.duplicates = json.data;
                this.count = json.count;
                this.loading = false;
            });
        }

        openDuplicateDialog(duplicate: any, $event: any): void {
            this.dialog
                .show({
                    component: "vc-duplicate-dialog",
                    targetEvent: $event,
                    scope: this.$scope,
                    skipHide: true,
                    clickOutsideToClose: false,
                    locals: {
                        duplicate: duplicate,
                    },
                    ariaLabel: "Review Duplicate Dialog",
                    class: "duplicate-dialog",
                    size: "large",
                })
                .then((data: any) => {
                    duplicate.status = "Merged";
                    this.toast.success(
                        this.$filter("capitalize")(this.__env.strings.voters) +
                            " merged"
                    );

                    duplicate.houseoccupants.secondary = null;
                    duplicate.houseoccupants.primary = data.primary;
                });
        }

        openViewHouseOccupantDialog(
            houseoccupant: HouseOccupant,
            $event: any
        ): void {
            this.dialog.show({
                component: "vc-view-house-occupant",
                targetEvent: $event,
                scope: this.$scope,
                skipHide: true,
                clickOutsideToClose: true,
                locals: {
                    selectedHoid: houseoccupant.hoid,
                },
                ariaLabel: "View Person",
                size: "large",
            });
        }

        setStatus(duplicate: any, status: string): void {
            duplicate.status = status;
            this.dataProvider.update({
                id: duplicate.id,
                status: status,
            });
        }
    },
};

angular
    .module("duplicates")
    .component(DuplicatesComponent.selector, DuplicatesComponent);
